import type { DateTime } from "luxon";
import type { TrajectoryPointDtoVehicleType } from "@/api/generated/models/trajectoryPointDtoVehicleType";
import { backendHostName } from "@/utils/constants";

export function buildTileUrl(dataSource: string, params: string[]): string {
  const base = `${backendHostName}/api/v0/tiles/${dataSource}/{z}/{x}/{y}`;
  const queryString = params.join("&");
  return `${base}?${queryString}`;
}

export function buildBaseTileFilterParams(filters: {
  vehicleTypes?: TrajectoryPointDtoVehicleType[];
  startTimestamp?: DateTime | null;
  endTimestamp?: DateTime | null;
}): string[] {
  const params: string[] = [];

  if (filters.vehicleTypes && filters.vehicleTypes.length > 0) {
    params.push(`vehicleTypes=${filters.vehicleTypes.join(",")}`);
  }

  if (filters.startTimestamp?.isValid) {
    const iso = filters.startTimestamp.toISO({ includeOffset: false });
    if (iso) params.push(`startTimestamp=${iso}`);
  }

  if (filters.endTimestamp?.isValid) {
    const iso = filters.endTimestamp.toISO({ includeOffset: false });
    if (iso) params.push(`endTimestamp=${iso}`);
  }

  return params;
}
